  <div class="quiz-container">
    <div class="quiz-header card-style">
    <ng-container *ngIf="isLoading; else pageContent">
          <div class="small-spinner ">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
      </ng-container>

    <ng-template #pageContent>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
        <i class="bi bi-arrow-left back-link" (click)="goToClassroomDetailPage()" ></i>
      <div class="quiz-title ms-2" *ngIf="fullQuizData">
        <span>{{fullQuizData.quiz_name || '-'}}
      <ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
          <i class="bi bi-pencil edit-icon ms-2" (click)="openEditTitleBox(false)"> </i>
      </ng-container>
    </span>
          </div>
    </div>

    <div class="text-end fw-bold">
    Time Limit
    <span class="quiztime ms-2">{{ formatTime(fullQuizData.time_limit || 0) }}
        <ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
      <i  class="bi bi-pencil edit-icon ms-2" (click)="openEditTitleBox(true)"></i>
      </ng-container>
    </span>
        </div>
    </div>
      </ng-template>
    </div>

  <div class="quiz-mode-tabs">
    <button (click)="selectMode('manual')" [class.active]="selectedMode === 'manual'"><i
        class="bi bi-pencil-square"></i>Create Manually</button>

    <button (click)="selectMode('ai')" [class.active]="selectedMode === 'ai'">
      <i class="bi bi-stars"></i> Generate with AI</button>

    <button (click)="selectMode('course')" [class.active]="selectedMode === 'course'"
      *ngIf="!hideFromCourseTab"><i
        class="bi bi-journal-bookmark"></i>From Course</button>
        
      <button (click)="selectMode('csv')" [class.active]="selectedMode === 'csv'"><i
        class="bi bi-journal-bookmark"></i> Upload Question via CSV</button>

    <button (click)="selectMode('pdf')" [class.active]="selectedMode === 'pdf'"><i
        class="bi bi-filetype-pdf"></i> Upload Question via PDF</button>

  </div>

  <app-manual-mode *ngIf="selectedMode === 'manual'"></app-manual-mode>
  <app-ai-mode *ngIf="selectedMode === 'ai'" (switchMode)="selectMode($event)"></app-ai-mode>
  <app-course-mode *ngIf="selectedMode === 'course'" (switchMode)="selectMode($event)"></app-course-mode>
  <app-csv-mode *ngIf="selectedMode === 'csv'" (switchMode)="selectMode($event)"></app-csv-mode>
  <app-pdt-doc-mode *ngIf="selectedMode === 'pdf'" (switchMode)="selectMode($event)"></app-pdt-doc-mode>

  <div class="footer">
    <h6 class="warning"><i class=" text-warning bi bi-exclamation-triangle-fill"></i> AI can make mistakes. Please review before publishing.</h6>
	<button class="btn-primary" (click)="goToQuizPage()" [disabled]="!quizDataExists">Review & Edit Questions</button>
  </div>
</div>